export const static_skillList = {
  ['Communication']: [
    'Read for understanding and inference',
    'Use appropriate forms of language depending on context eg written, online, speaking',
    'Provide and accept meaningful feedback',
    'Provide and accept constructive feedback',
    'Interpret communication through intercultural understanding',
    'Communicate with different audiences types using a variety of speaking techniques',
    'Adapt the form of writing according to purpose and audience',
    'Communicate with a variety of audiences using a range of media',
    'Use and interpret ways of non - verbal communication',
    'Open negotiation with peers and teachers regarding ideas and knowledge',
    'Active participant in digital social media networks',
    'Use social media to collaborate with peers and experts',
    'Use social media to share ideas',
    'Reading critically',
    'Reading for comprehension',
    'Reading for information and pleasure',
    'Draw conclusions and make inferences',
    'Effective use of discipline - specific terms and symbols',
    'Writing for a range of purposes',
    'Use and understand mathematical notation',
    'Accurate use of paraphrasing',
    'Build understanding through preview and skimming text',
    'Note - taking effectively in class',
    'Summary note - taking for study and revision',
    'Use a range of planners and organisers to support writing tasks',
    'Use a variety of media to find information for inquiry',
    'Logical organization, structure and depiction of information'
  ],
  ['Collaboration']: [
    'Collaborate with other students to complete tasks or solve problems',
    'Seek expert advice',
    'Provide advice or assistance to others',
    'People management(empowering others, listening, coaching, empathy)',
    'Leadership(vision, communication, role modeling)',
    'Human interaction skills – interpersonal, relationship, social and emotional skills',
    'Civic engagement skills – social participation, community dialogue',
    'Build and develop relationships through using social media networks appropriately',
    "Practice empathy for better relationships by putting yourself in somebody else 's shoes and understand how they might be feeling in a given situation",
    'In decision - making share responsibility through delegation',
    'Accept one’s own actions are one’s own responsibility',
    'Conflict resolution through collaboration',
    'Consensus building',
    'Fair and equitable decision - making',
    'Active listening to appreciate other perspectives',
    'Effective negotiation',
    'Encourage contribution from team members',
    'Adopt a variety of roles within groups and exercise leadership',
    'Incorporate feedback in changing actions',
    'Stand up for your rights and needs'
  ],
  ['Organization']: [
    'Have the correct materials for learning',
    'Use graphic organizers',
    'Plan time allocation for tasks',
    'Financial management',
    'Entrepreneurship(inc.social change through entrepreneurship)',
    'Meet deadlines by planning for short and long term assignments',
    'Design revision timetables and plans for exam sessions',
    'Utilise a planner (daily or weekly) for assignments',
    'Set challenging and realistic goals',
    'Set goals that are SMART for months, terms, semesters or years',
    'Appreciate the links between goal - setting, optimism and resilience.',
    'Achieve personal and academic goals by planning strategies and taking action',
    'Ensure you are equipped in all lessons',
    'Design and keep a logical system of files / notebooks',
    'Organize complex information using appropriate strategies',
    'Awareness of preferred learning styles',
    'Use strategies to accommodate preferred learning styles',
    'Select and use the right technology at the right time'
  ],
  ['Affective']: [
    'Identify areas of strength and challenge in learning',
    'Recover from setbacks',
    'Persevere through challenging tasks or situations',
    'Ask for help',
    'Mindfulness strategies: focus and concentration, develop mental focus, overcome distractions, aware of body–mind connections',
    'Demonstrate persistence and perseverance and delaying gratification',
    'Emotional management strategies: overcome impulsiveness and anger, prevent and eliminate bullying, reduce stress and anxiety',
    'Self - motivation strategies: analysing and attributing causes for failure, managing self - talk, positive thinking, using goal - setting for motivation',
    'Resilience strategies: “bouncing back” after adversity, mistakes and failures, “failing well”, dealing with disappointment and unmet expectations, dealing with change, using goal - setting in creating optimism, self - belief and resilience',
    'Understand growth and fixed mindsets and change performance accordingly',
    'Explain the role of neural plasticity'
  ],
  ['Reflection']: [
    'Adapt learning by developing new skills, techniques and strategies',
    'Self - assess to identify strengths and weaknesses of personal learning',
    'Be flexible in selecting and using learning strategies',
    'Try skills and evaluate how effective they were',
    'Reflect on content: What did I learn today? What don’t I understand yet? What questions do I now have?',
    'Reflect on skills: What can I do already? How can I share my skills to help classmates? What will I work to develop next?',
    'Reflect on strategies: What can I do to become more efficient and effective as a learner? Do I need to be more flexible in my choice of learning strategies? What factors help me learn well?',
    'Focus on creating by imitating',
    'Change actions according to ethical, cultural or environmental implications',
    'Record reflections in a journal (online or hard copy)'
  ],
  ['Information literacy']: [
    'Computational skills – leveraging the power of computers to harness algorithmic thinking to become an effective problem solver in technology rich environments',
    'Collect and record data',
    'Verify data',
    'Find connections between different sources of information',
    'When accessing, processing and recalling information, appreciate the benefits and limitations of your own learning preferences',
    'Develop long - term memory by using memory techniques',
    'Use a variety of formats and platforms to present information',
    'Identify solutions and make informed decisions based on data collected and analysed',
    'Process data',
    'Report results of processed data',
    'Information sources evaluated and selected based on their appropriateness to specific tasks',
    'Analyse and interpret media communications using critical - literacy skills',
    'Understand intellectual property rights',
    'Create references and citations according to recognized conventions',
    'Use footnotes / endnotes according to recognized conventions',
    'Construct a bibliography according to recognized conventions',
    'Primary and secondary sources identification'
  ],
  ['Media Literacy']: [
    'Analyze validity and reliability of sources',
    'Use information from a variety of sources and media',
    'Locate, organize, analyse, evaluate, synthesize information',
    'Show awareness of media interpretations of events and ideas',
    'Make informed choices regarding viewing experiences',
    'Analyse the impact of media representations',
    'Find a range of perspectives from many sources',
    'Use a variety of media and formats to communicate information and ideas to multiple audiences',
    'Compare, contrast and find connections among resources'
  ],
  ['Critical Thinking']: [
    'Recognize problems through careful observation',
    'Formulate an argument by gathering and organizing relevant information',
    'Recognize assumptions and bias which may be unstated',
    'Data interpretation',
    'Evaluate evidence',
    'Evaluate arguments',
    'Recognize propositions',
    'Evaluate propositions',
    'Draw conclusions and generalizations',
    'Test generalizations',
    'Test conclusions',
    'Use new information and evidence to revise understanding',
    'Risk management and evaluation',
    'Write factual, conceptual and debatable questions',
    'View ideas from multiple perspectives',
    'Develop opposing arguments',
    'Break down complex concepts and ideas into their parts and synthesize them to create new understanding',
    'Propose and evaluate a range of solutions',
    'Identify challenges and potential obstacles',
    'Explore complex systems and issues by using models and simulations',
    'Forecast possibilities and identify trends',
    'Troubleshoot systems'
  ],
  ['Creative Thinking']: [
    'Generate new ideas and inquiries through brainstorming and visual diagrams',
    'Consider multiple alternatives, even if they appear impossible',
    'Design original solutions to authentic problems',
    'Find unusual connections between ideas',
    'Design better versions of existing technologies',
    'Design new technologies',
    'Write testable hypotheses, make guesses, and ask “what if” questions',
    'Use existing knowledge to create new ideas, products or processes',
    'Show originality and use existing works or ideas in new ways',
    'Show flexible thinking by developing many opposing, contradictory and complementary arguments',
    'Use visible thinking strategies',
    'Create metaphors and analogies'
  ],
  ['Transfer']: [
    'Use learning strategies in subjects',
    'In unfamiliar situations, apply skills and knowledge',
    'Gain a different perspective through inquiring in different contexts',
    'Compare and connect conceptual understanding across subjects',
    'Bring together knowledge, skills and understanding to address products or solutions',
    'Learn new technologies through the transfer of current knowledge',
    'Gain different perspectives by changing the context of an inquiry'
  ]
};



// WEBPACK FOOTER //
// ./src/skillList.js